import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { PoAutoSettingPage } from './po-auto-setting.page';

const routes: Routes = [
  {
    path: '',
    component: PoAutoSettingPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PoAutoSettingPageRoutingModule {}
